
import { FieldValidator } from './field-validator'
import { isMMDDYYYY } from './is-mmddyyyy'
import * as _ from 'lodash'

export class DateTextFieldValidator implements FieldValidator<string> {
    constructor(private allowsBlank = false) {}

    validate(text: string, fieldName: string): Promise<string> {
        return new Promise((resolve, reject) => {
            if (this.allowsBlank && _.isEmpty(text)) {
                resolve('')
            }
           if(text!= undefined && text!='' && text!= null){
            if (isMMDDYYYY(text)) {
                resolve('')
            } else {
                reject(`${fieldName} must be MM/DD/YYYY`)
            }
        }
        else  
        reject(`${fieldName} ${'cannot be blank'}`)
        })
    }
}
